import React from 'react';
import { Link } from 'react-router-dom';

import BotonEditar from './BotonEditar.jsx';

import ProcessManager from '../../../Common/Managers/ProcessManager';

const HeaderButtons = (props) => {
    return (
        <div className="row">
            <div className="left-separator-xs">
                <BotonEditar functions={props.functions} />               
            </div>
        </div>
    );
}

export default HeaderButtons